export default __webpack_public_path__ + "static/media/img_scsc_2.47942ca3.png";